export default {
  // =========================================================================
  // SECTOR IMPORTANCE
  // =========================================================================
  waspi_opinion: {
    type: "categorical",
    label: "Opinion of WASPI campaign",
    category: "waspi",
    fulltext: "Given what you know today, which of the following best describes your opinion about the WASPI (Women Against State Pension Inequality) campaign?",
    client: ["waspi", "stack-data-strategy"],
    keys: [
  "waspi_opinion_genuinely_wronged_fully",
  "waspi_opinion_wronged_some",
  "waspi_opinion_wronged_no_comp",
  "waspi_opinion_not_wronged",
  "waspi_opinion_heard_no_opinion",
  "waspi_opinion_not_heard",
  "waspi_opinion_dk"
    ],
    labels: {
  "waspi_opinion_genuinely_wronged_fully":"These women were genuinely wronged and should be fully compensated",
  "waspi_opinion_wronged_some":"These women were wronged and deserve some recompense",
  "waspi_opinion_wronged_no_comp":"These women were wronged but I don’t think they should be compensated ",
  "waspi_opinion_not_wronged":"These women were not wronged at all",
  "waspi_opinion_heard_no_opinion":"I have heard of WASPI, but have no opinion",
  "waspi_opinion_not_heard":"I have never heard of WASPI",
  "waspi_opinion_dk":"Don’t know"
    },
    colors: {
  "waspi_opinion_genuinely_wronged_fully":"#33691E",
  "waspi_opinion_wronged_some":"#388E3C",
  "waspi_opinion_wronged_no_comp":"#F9A825",
  "waspi_opinion_not_wronged":"#C62828",
  "waspi_opinion_heard_no_opinion":"#8D6E63",
  "waspi_opinion_not_heard":"#37474F",
  "waspi_opinion_dk":"#777777"
    },
    schema: "tracking",
    waves: [5]
  },


waspi_action: {
    type: "categorical",
    label: "Preferred WASPI outcome",
    category: "waspi",
    fulltext: "The Parliamentary Ombudsman ruled in 2024 that WASPI women should be compensated. There are a range of things the Government could do. Of these, which - if any - would you MOST support?",
    client: ["waspi", "stack-data-strategy"],
    keys: [
  "waspi_actions_maximum_compensation_10bill",
  "waspi_actions_maximum_compensation_2point9k",
  "waspi_actions_minimum_compensation_3bill",
  "waspi_actions_minimum_compensation_1k",
  "waspi_actions_discretionary_compensation",
  "waspi_actions_proportionate_amount",
  "waspi_actions_means_tested_2point9k",
  "waspi_actions_means_tested_1k",
  "waspi_actions_early_access",
  "waspi_actions_none"
    ],
    labels: {
  "waspi_actions_maximum_compensation_10bill":"Those affected being paid the maximum compensation possible, costing up to £10.3bn",
  "waspi_actions_maximum_compensation_2point9k":"Those affected being paid the maximum compensation of £2,950 per woman",
  "waspi_actions_minimum_compensation_3bill":"Those affected being paid the minimum compensation possible, costing up to £3.5bn",
  "waspi_actions_minimum_compensation_1k":"Those affected being paid the minimum compensation of £1,000 per woman",
  "waspi_actions_discretionary_compensation":"Those affected being paid discretionary compensation of up to £500 per woman - if they apply for it - costing up to £1.8bn",
  "waspi_actions_proportionate_amount":"Those affected being paid proportionate amounts of compensation of anywhere between £1,000 and £2,950 per woman, dependent on the length of notice received and how long they waited for their State Pension",
  "waspi_actions_means_tested_2point9k":"Those affected being paid compensation on a means-tested basis, of up to £2,950 per woman",
  "waspi_actions_means_tested_1k":"Those affected being paid compensation on a means-tested basis, of up to £1,000 per woman",
  "waspi_actions_early_access":"Those affected receiving non-financial compensation in the form of free or early access to services",
  "waspi_actions_none":"None of these"
    },
    colors: {
  "waspi_actions_maximum_compensation_10bill":"#1B5E20",
  "waspi_actions_maximum_compensation_2point9k":"#2E7D32",
  "waspi_actions_minimum_compensation_3bill":"#558B2F",
  "waspi_actions_minimum_compensation_1k":"#7CB342",
  "waspi_actions_discretionary_compensation":"#F9A825",
  "waspi_actions_proportionate_amount":"#EF6C00",
  "waspi_actions_means_tested_2point9k":"#00838F",
  "waspi_actions_means_tested_1k":"#26A69A",
  "waspi_actions_early_access":"#8D6E63",
  "waspi_actions_none":"#C62828"
    },
    schema: "tracking",
    waves: [5]
  },

  waspi_labour_vote: {
    type: "likert",
    label: "Impact of WASPI inaction on vote",
    category: "waspi",
    fulltext: "If a new Labour leader REFUSED to compensate WASPI women, would it make you more or less likely to vote for Labour at the next General Election?",
    client: ["waspi", "stack-data-strategy"],
   keys: [
  "waspi_labour_vote_much_more",
  "waspi_labour_vote_bit_more",
  "waspi_labour_vote_no_difference",
  "waspi_labour_vote_bit_less",
  "waspi_labour_vote_much_less",
  "waspi_labour_vote_dk",
    ],
    labels: {
  "waspi_labour_vote_much_more":"Much more likely",
  "waspi_labour_vote_bit_more":"A bit more likely",
  "waspi_labour_vote_no_difference":"It would make no difference",
  "waspi_labour_vote_bit_less":"A bit less likely",
  "waspi_labour_vote_much_less":"Much less likely",
  "waspi_labour_vote_dk":"Don't know",
    },
    polarity: {
      pos: ["waspi_labour_vote_much_more", "waspi_labour_vote_bit_more"],
      neu: "waspi_labour_vote_no_difference",
      neg: ["waspi_labour_vote_bit_less", "waspi_labour_vote_much_less"],
      dk:  "waspi_labour_vote_dk",
    },
    schema: "tracking",
    waves: [5]
  },

};
